import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonScrollBox } from './ScrollBox.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonScrollBox({ prefix }));
}
